export default __webpack_public_path__ + "static/media/logo.801b1472.gif";